import { AxiosError, AxiosRequestConfig } from 'axios';

export class IntermindError extends Error {
  readonly statusCode?: number;
  readonly code?: string;
  readonly url?: string;
  readonly data?: Record<string, unknown>;
  readonly request?: AxiosRequestConfig;

  constructor(error: Error | AxiosError) {
    super(error.message);
    if (error instanceof AxiosError) {
      this.message = error.response?.data?.message ?? error.message;
      this.statusCode = error.response?.status;
      this.code = error.response?.data?.code;
      this.url = error.config?.url;
      this.data = error.response?.data;
      this.request = error.config;
    }
  }
}
